// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
   

  adresseUrl: 'http://34.125.11.74:',
  
  serverFinanceAdresse:'http://34.125.11.74:4224'
  ,serverAdresse:'http://34.125.11.74:4200'
  ,erpAdresse:'http://34.125.11.74:4223'
  
  ,restApi: 'http://34.125.11.74:8080/prospect/webresources/'
  ,restApiERP: 'http://34.125.11.74:8080/back-napec2022/webresources/'
  ,restApiAncienERP: 'http://34.125.11.74:8080/back-napec2020/webresources/'
  ,restApiCRM: 'http://34.125.11.74:8080/crm-1/webresources/'
  ,serverNPAECAdresse:'http://34.125.11.74:8080/NAPEC2020/index.xhtml',
   
  
  
  /*

    adresseUrl: 'http://localhost:',


  serverFinanceAdresse:'http://localhost:4224'
  ,serverAdresse:'http://localhost:4200'
  ,erpAdresse:'http://localhost:4223'
  
  ,restApi: 'http://localhost:8083/prospect/webresources/'
  ,restApiERP: 'http://localhost:8083/back-napec2022/webresources/'
  ,restApiAncienERP: 'http://localhost:8083/back-napec2020/webresources/'
  ,restApiCRM: 'http://localhost:8083/crm-1/webresources/'
  ,serverNPAECAdresse:'http://localhost:8080/NAPEC2020/index.xhtml',
  */
  

  firebaseConfig: {
    apiKey: "AIzaSyDazVJijQvxOMT9bLMebhxsQWd-jbBLH0M",
    authDomain: "badgesnapec.firebaseapp.com",
    databaseURL: "https://badgesnapec.firebaseio.com",
    projectId: "badgesnapec",
    storageBucket: "badgesnapec.appspot.com",
    messagingSenderId: "204195867803",
    appId: "1:204195867803:web:518c58b19677c1dc89aa3e",
    measurementId: "G-LKLRK0F9JK"
  }
  // ,restApiOnline: 'http://192.168.92.200:8083/OnlinePortailm-1.0/webresources/'
};


/*


  serverFinanceAdresse:'http://localhost:4224'
  ,serverAdresse:'http://localhost:4200'
  ,erpAdresse:'http://localhost:4223'

  ,restApi: 'http://localhost:8083/prospect/webresources/'
  ,restApiERP: 'http://localhost:8083/back-napec2022/webresources/'
  ,restApiAncienERP: 'http://localhost:8083/back-napec2020/webresources/'
  ,restApiCRM: 'http://localhost:8083/crm-1/webresources/'
  ,serverNPAECAdresse:'http://localhost:8080/NAPEC2020/index.xhtml',


  adresseUrl: 'http://34.125.11.74:',

     serverFinanceAdresse:'http://34.125.11.74:4224'
  ,serverAdresse:'http://34.125.11.74:4200'
  ,erpAdresse:'http://34.125.11.74:4223'

  ,restApi: 'http://34.125.11.74:8080/prospect/webresources/'
  ,restApiERP: 'http://34.125.11.74:8080/back-napec2022/webresources/'
    ,restApiAncienERP: 'http://34.125.11.74:8080/back-napec2020/webresources/'
  ,restApiCRM: 'http://34.125.11.74:8080/crm-1/webresources/'
  ,serverNPAECAdresse:'http://34.125.11.74:8080/NAPEC2020/index.xhtml',





*/






/*



 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
